"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const driversData = [{
  id: "growth",
  title: "Aizalea Token Price",
  description: "Current price: 1 USDT\nEarly investors can access the Aizalea token before the next presale phase, where the price is expected to increase to 3 USDT.\n",
  image: "https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/13546CDB-1A38-483F-BF4E-9EBBC6BE2074.png?v=t0721zbiqgl"
}, {
  id: "utility",
  title: "Exclusive Token Bonus",
  description: "Early participants receive additional token bonuses depending on the size of their investment, rewarding long-term supporters of the AizaHcare ecosystem.",
  image: "https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/034B58CE-5C88-4E22-BA2B-4EC20E18ADAD.png?v=sfecuhc05gc"
}, {
  id: "infrastructure",
  title: "Global Token Potential",
  description: "Aizalea supports a real AI healthcare infrastructure including medical centers, proprietary clinical data, and AI-powered health solutions designed to scale globally.",
  image: "https://positive-cattle.10web.cloud/wp-content/uploads/2026/03/Token_aizalea.mp4?v=xzth5607qu"
}];
export default function TokenValueDrivers() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="109237" id="aizaleatokenvalue" className="bg-background text-foreground py-[160px] overflow-hidden relative">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/5 to-background pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-sans font-bold text-4xl md:text-5xl text-foreground tracking-tight mb-6">Aizalea Token Value Growth</h2>
          <p className="font-sans text-lg leading-relaxed !text-[hsl(0,0%,0%)] md:text-xl">Aizalea is the utility token powering the AizaHcare ecosystem, built on real-world infrastructure, clinical data, and AI healthcare solutions.&nbsp;<div data-ast-id="f:/src/pages/AizaleaAIHealthcareUtilityToken/sections/TokenValueDrivers.tsx|sig:55fe54" data-ast-start="2290" data-ast-end="2307"><br /></div><div data-ast-id="f:/src/pages/AizaleaAIHealthcareUtilityToken/sections/TokenValueDrivers.tsx|sig:55178m" data-ast-start="2307" data-ast-end="2445" className="!text-[hsl(217,91%,60%)]">The current price is 1 USDT during Presale Phase, with the next presale phase planned at 3 USDT before the official listing.</div></p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {driversData.map((driver, i) => {
          const cardReveal = useRevealOnScroll({
            threshold: 0.2
          });
          return <div key={driver.id} data-index={i} ref={cardReveal.ref} className={`transition-all duration-1000 ease-out delay-[${i * 150}ms] ${cardReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full bg-card border-border shadow-sm hover:shadow-md transition-shadow duration-500 rounded-xl overflow-hidden group">
                  <CardHeader className="pb-4 pt-0 px-8">
                    <img src={driver.image} alt={driver.title} className="w-[calc(100%+64px)] -mx-8 h-[280px] object-cover max-w-none mb-8 group-hover:scale-103 transition-transform duration-700 ease-out" />
                    <CardTitle className="font-sans font-bold text-2xl text-foreground tracking-tight">
                      {driver.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-10">
                    <p className="font-sans text-muted-foreground leading-relaxed text-base">
                      {driver.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="flex justify-center mt-20">
          <Button asChild size="lg" className="rounded-full px-12 py-7 h-auto text-lg font-bold bg-primary text-primary-foreground hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-primary/20">
            <Link to="#buy-token">
              Buy Aizalea Utility Token
            </Link>
          </Button>
        </div>

      </div>
    </section>;
}